(() => {
    // --- CONFIGURATION ---
    // These are standard selectors. If your theme uses weird classes, we might need to tweak these.
    const SELECTORS = {
        container: "#custom-bogo-progress-container",
        cartDrawer: "cart-drawer",
        qtyInput: "input[name='updates[]'], input.quantity__input, input[type='number']",
        plusBtn: "button[name='plus'], .quantity__button--plus, .plus",
        minusBtn: "button[name='minus'], .quantity__button--minus, .minus"
    };

    // --- STATE MANAGEMENT ---
    let currentCartCount = 0;

    // Helper: Calculate discount tier based on count
    const getTierData = (count) => {
        if (count <= 0) return { width: "0%", step: 0, msg: "Add 1 item to unlock <span class='bogo-highlight'>10% OFF</span>" };
        if (count === 1) return { width: "10%", step: 1, msg: "Add a little extra. Level up your calm like it’s self-care couture." };
        if (count === 2) return { width: "50%", step: 2, msg: "Move light. Upgrade your calm — the quiet flex that actually hits." };
        return { width: "100%", step: 3, msg: "More cans. More clarity. More calm. That’s premium peace on tap." };
    };

    // --- RENDERER (DOM PATCHING) ---
    const updateBarVisuals = (count) => {
        const container = document.querySelector(SELECTORS.container);
        const cartDrawer = document.querySelector(SELECTORS.cartDrawer);
        
        if (!container) return;

        // Handle Empty State Visibility
        if (count > 0) {
            container.classList.add("is-ready");
            if (cartDrawer) cartDrawer.classList.remove("wt-cart--empty");
        } else {
            container.classList.remove("is-ready");
            if (cartDrawer) cartDrawer.classList.add("wt-cart--empty");
            return; 
        }

        const data = getTierData(count);
        let wrapper = container.querySelector(".bogo-wrapper");

        // If wrapper doesn't exist, create it (First Run)
        if (!wrapper) {
            container.innerHTML = `
                <div class="bogo-wrapper">
                    <div class="bogo-message">${data.msg}</div>
                    <div class="bogo-progress-track">
                        <div class="bogo-progress-fill" style="width: ${data.width};"></div>
                    </div>
                    <div class="bogo-steps">
                        <div class="bogo-step" data-step="1"><div class="bogo-step-circle">1</div><div class="bogo-step-label">10% OFF</div></div>
                        <div class="bogo-step" data-step="2"><div class="bogo-step-circle">2</div><div class="bogo-step-label">20% OFF</div></div>
                        <div class="bogo-step" data-step="3"><div class="bogo-step-circle">3+</div><div class="bogo-step-label">30% OFF</div></div>
                    </div>
                </div>`;
            wrapper = container.querySelector(".bogo-wrapper");
        }

        // FAST UPDATE: Directly manipulate DOM elements
        const msgEl = wrapper.querySelector(".bogo-message");
        const fillEl = wrapper.querySelector(".bogo-progress-fill");
        const steps = wrapper.querySelectorAll(".bogo-step");

        if (msgEl && msgEl.innerHTML !== data.msg) msgEl.innerHTML = data.msg;
        if (fillEl) fillEl.style.width = data.width;

        steps.forEach((step, idx) => {
            const stepNum = idx + 1;
            const circle = step.querySelector(".bogo-step-circle");
            
            if (data.step >= stepNum) {
                step.classList.add("is-active");
                if (stepNum === 3) step.classList.add("is-max-active");
                if (circle) circle.innerText = "✓";
            } else {
                step.classList.remove("is-active", "is-max-active");
                if (circle) circle.innerText = stepNum === 3 ? "3+" : stepNum;
            }
        });
    };

    // --- OPTIMISTIC LISTENER (ZERO DELAY) ---
    const setupOptimisticUI = () => {
        // We listen to the whole document for clicks on plus/minus buttons
        document.addEventListener("click", (e) => {
            const target = e.target;
            const cartDrawer = target.closest(SELECTORS.cartDrawer) || document.querySelector(SELECTORS.cartDrawer);
            
            // Ensure we are interacting inside the cart drawer
            if (!cartDrawer || !cartDrawer.contains(target)) return;

            // Check if Plus or Minus was clicked
            const isPlus = target.matches(SELECTORS.plusBtn) || target.closest(SELECTORS.plusBtn);
            const isMinus = target.matches(SELECTORS.minusBtn) || target.closest(SELECTORS.minusBtn);

            if (isPlus || isMinus) {
                // 1. Calculate current visible total immediately
                const inputs = cartDrawer.querySelectorAll(SELECTORS.qtyInput);
                let visibleTotal = 0;
                inputs.forEach(input => {
                    visibleTotal += parseInt(input.value || 0);
                });

                // 2. Predict the new total
                let predictedTotal = visibleTotal;
                if (isPlus) predictedTotal += 1;
                if (isMinus) predictedTotal -= 1;

                // 3. Update visuals INSTANTLY
                if (predictedTotal >= 0) {
                    console.log("Optimistic Update:", predictedTotal);
                    currentCartCount = predictedTotal; // Update global state
                    updateBarVisuals(predictedTotal);
                }
            }
        });
    };

    // --- SERVER SYNC (SOURCE OF TRUTH) ---
    // We still fetch to confirm, in case the network request failed or logic was off
    const fetchCartAndSync = () => {
        fetch("/cart.js")
            .then(res => res.json())
            .then(cart => {
                currentCartCount = cart.item_count;
                updateBarVisuals(currentCartCount);
            })
            .catch(err => console.error(err));
    };

    // --- INIT ---
    setupOptimisticUI(); // Turn on zero-delay clicking
    fetchCartAndSync();  // Initial Load

    // --- BACKUP LISTENERS ---
    // Keep these to sync up if something else modifies the cart (like a product page add)
    
    // Fetch Interceptor (Updates background data)
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
        const url = args[0];
        if (typeof url === "string" && (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update"))) {
            return originalFetch.apply(this, args).then((response) => {
                // We wait a tiny bit just to let the backend finish, then sync truth
                // This "corrects" the bar if the optimistic prediction was wrong
                setTimeout(fetchCartAndSync, 500); 
                return response;
            });
        }
        return originalFetch.apply(this, args);
    };

    // Theme Specific Events
    document.addEventListener("cart-drawer:refresh", fetchCartAndSync);
    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
        subscribe(PUB_SUB_EVENTS.cartUpdate, fetchCartAndSync);
    }
})();